import { FaArrowRight, FaBook, FaBookOpen, FaBookmark, FaCircleInfo, FaDatabase, FaHospital, FaLaptop, FaLock, FaMicrophone } from "react-icons/fa6"
import { FaBookReader, FaSearch } from "react-icons/fa";
import Heading from "../components/heading"
import { IoIosChatbubbles } from "react-icons/io";
import Card from "../components/campusLife/card";
import ServiceSlider from "../components/campusLife/serviceSlider";
import { PropTypes } from 'prop-types';
import OperatingHours from "./operatingHours";
import Facilities from "./facilities";
import { useSelector } from "react-redux";
import { DecodeHtml } from "../utils/decodeHtml";
import { Link } from "react-router-dom";
import { retrunAssets } from "../utils/getAssets";


const CardRow = ({ cards }) => {
    return (
        <div
            className="flex items-center justify-center p-4 border border-gray-300 rounded-lg shadow-md hover:shadow-lg transition duration-300 ease-in-out my-5">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4  gap-4 ">
                {
                    cards?.map((service, index) => (
                        <div
                            className={`flex flex-col  max-w-[25rem] gap-4 p-4 ${index < (cards.length - 1) && "border-b sm:border-b-0 sm:border-r border-dashed border-gray-300"} `}
                            key={index}>
                            <Card {...service} position="items-center text-center" />
                        </div>
                    ))
                }

            </div>
        </div>
    )
}
CardRow.propTypes = {
    cards: PropTypes.array
}


const CampusServices = () => {

    const state = useSelector(state => state.campusLifeTab)
    const campusServices = state?.data?.properties
    const iRCDescription = campusServices?.iRCDescription?.markup

    const icons = [
        <FaBook size={25} key={1} />,
        <IoIosChatbubbles size={25}  key={2} />,
        <FaSearch size={25} key={3} />,
        <FaCircleInfo size={25} key={4} />,
        <FaDatabase size={25} key={5} />,
        <svg key={6} width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M30 13.3594C29.1094 13.6875 28.5 14.5312 28.5 15.4688C28.5 16.4531 29.1094 17.2969 30 17.625V22.2188H0V17.625C0.84375 17.2969 1.5 16.4531 1.5 15.4688C1.5 14.5312 0.84375 13.6875 0 13.3594V11.7188C0 10.9219 0.65625 10.2188 1.5 10.2188H28.5C29.2969 10.2188 30 10.9219 30 11.7188V13.3594ZM10.5 19.2188V13.2188H7.5V19.2188H10.5ZM16.5 19.2188V13.2188H13.5V19.2188H16.5ZM22.5 19.2188V13.2188H19.5V19.2188H22.5ZM0 28.2188V23.7188H30V28.2188H27V27C27 26.5781 26.625 26.25 26.25 26.25C25.8281 26.25 25.5 26.5781 25.5 27V28.2188H19.5V27C19.5 26.5781 19.125 26.25 18.75 26.25C18.3281 26.25 18 26.5781 18 27V28.2188H12V27C12 26.5781 11.625 26.25 11.25 26.25C10.8281 26.25 10.5 26.5781 10.5 27V28.2188H4.5V27C4.5 26.5781 4.125 26.25 3.75 26.25C3.32812 26.25 3 26.5781 3 27V28.2188H0Z" fill="#081330" />
        </svg>
    ]

    const cards = campusServices?.iRCAmenitiesRow?.items?.map((item,index)=>{
        let card = item?.content?.properties
        return (
            {
                icon: card?.icon !== null ? retrunAssets(card.icon[0].url) : icons[index],
                title:card?.title,
                description: DecodeHtml({html:card?.content?.markup})
            }
        )
    })

   const servicesIcons = [
        <FaHospital size={30} key={1} />,
        <FaBookmark size={30} key={2} />,
        <FaBookOpen size={30} key={3} />,
        <FaBook size={30} key={4} />,
        <FaLock size={30} key={5} />,
        <FaBookReader size={30} key={6} />,
        <FaMicrophone size={30} key={7} />,
        <FaLaptop size={32} key={8} />,
        <FaLock size={30} key={9} />,
        <FaBookReader size={30} key={10} />,
        <FaMicrophone size={30} key={11} />,
        <FaLaptop size={32} key={12} />,

    ]

    const services = campusServices?.iRCAmenities?.items?.map((item,index)=>{
        let card = item?.content?.properties
        return (
            {
                icon: card?.icon !== null ? retrunAssets(card.icon[0].url) : servicesIcons[index],
                title:card?.title,
                description: DecodeHtml({html:card?.content?.markup})
            }
        )
    })

   const belowIRCSlidesDescription = DecodeHtml({html:campusServices?.belowIRCSlidesDescription?.markup})
    // const imgSlider = [
    //     "/assets/news_banner.svg",
    //     "/assets/news_banner.svg",
    // ]
    // const buttons = [
    //     "IRC WEBSITE",
    //     "OPAC",
    //     "UNITEN LIBGUIDES",
    //     "ONLINE RESOURCES",
    //     "DSPACE"
    // ]
    const imgSlider = campusServices?.accommodationSlideImages?.map(item=>retrunAssets(item?.url))
    const buttons = campusServices?.belowIRCButtons?.items?.map(item=>{
        let button = item?.content?.properties
        return (
            {
                label:button?.label,
                link:button?.link
            }
        )
    })
   
    return (
        <div className="flex flex-col gap-16 p-4 md:px-10">
            <div className="flex flex-col gap-10 ">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
                    <div className="grid grid-cols-1 gap-5">
                        <Heading name="Library" color="text-blue-700" />
                        <h1 className="w-auto  text-slate-900 text-5xl font-bold capitalize">UNITEN INFORMATION RESOURCE CENTRE (IRC)</h1>
                        <p className="w-auto  text-justify text-sky-950 text-opacity-70 text-base font-normal leading-normal">{
                            DecodeHtml({ html: iRCDescription })
                        }</p>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 mt-4">
                            {
                                cards?.map((card, index) => (
                                    <Card {...card} key={index} position="items-center justify-center text-center lg:text-left lg:items-start" />
                                ))
                            }
                        </div>
                    </div>
                    <div className="grid grid-cols-1 grid-flow-row h-fit gap-8">
                        <ServiceSlider imgs={imgSlider} />
                        <p className="w-auto  text-justify text-sky-950 text-opacity-70 text-base font-normal  leading-normal">{belowIRCSlidesDescription}</p>
                        <div className="flex flex-col gap-5">
                            {
                                buttons?.map((button, index) => (
                                    <Link to={button?.link} key={index} className="px-8 py-4 bg-red-800 rounded justify-center items-center gap-4 flex">
                                        <span className="text-white text-base font-bold  flex items-center gap-3">{button?.label} <FaArrowRight /></span>
                                    </Link>
                                ))

                            }
                        </div>
                    </div>
                </div>
               { services?.slice(0, 4)?.length > 0 && <CardRow cards={services?.slice(0, 4)} />}
              {services?.slice(4, 8)?.length > 0 && <CardRow cards={services?.slice(4, 8)} />}
                {services?.slice(8, 12)?.length > 0 && <CardRow cards={services?.slice(8, 12)} />}
                <OperatingHours />
                <Facilities />
            </div>

        </div>
    )
}

export default CampusServices